import { DateRange } from "@kargo/shared-components.krg-date-picker";
import { Video } from "../api/types";
import { MediaState } from "./media.types";

export type PlaylistActionType = "delete" | "copy";
export type PlaylistActionState = {
  isOpen: boolean;
  type: PlaylistActionType;
  playlist: Playlist | null;
};

export const enum PlaylistCreationEnum {
  TAG = "tag",
  CUSTOM = "custom",
  CATEGORY = "category",
}
export type PlaylistCreationType =
  (typeof PlaylistCreationEnum)[keyof typeof PlaylistCreationEnum];
export type PlaylistSortTypes = "newest" | "oldest" | "shuffle" | "manual";

type SortType = "asc" | "desc" | "ascending" | "descending" | 1 | -1;
// sort({ fieldOne: 'asc', secondField: -1 }) OR sort('fieldOne -secondField');
type Sort = string | { [key: string]: SortType };

export type PlaylistTagInput = {
  slug?: string;
  title?: string;
  key?: string;
  tags?: string[];
  excludedTags?: string[];
  username?: string;
  sort: "oldest" | "newest" | "shuffle";
};
export type PlaylistCategoryInput = {
  slug?: string;
  title?: string;
  key?: string;
  categories?: string[];
  username?: string;
  sort: "oldest" | "newest" | "shuffle";
};

export type PlaylistInput = {
  title?: string;
  key?: string;
  medias?: string[];
  username?: string;
  shuffle?: boolean;
  updated_at?: string;
  sort?: "oldest" | "newest" | "shuffle" | "manual";
};

export type Playlist = PlaylistInput & {
  token: string;
  medias: string[];
};

export type PlaylistResponse = {
  title: string;
  shuffle: boolean;
  medias: Video[];
  token: string;
  created_at: string;
  created_by: string;
  tags: string[];
  categories: string[];
  excludedTags: string[];
  type: PlaylistCreationType;
  sortType: PlaylistSortTypes;
};

export type PlaylistSingleMediaAudioTranscription = {
  words: string[];
  scores: string[];
  times: string[];
  topics: string[];
  keywords: string[];
};

export type PlaylistSingleMediaInfo = {
  duration: number;
  original_file_name: string;
  original_extension: string;
  size: number;
  width: number;
  height: number;
};

export type PlaylistSingleMediaDefaultStream = {
  media_info: PlaylistSingleMediaInfo;
  file_path: string;
  token: string;
  image_path: string;
  url: string;
  image_url: string;
};

export type PlaylistSingleMedia = {
  id: string | number;
  title: string;
  description: string;
  token: string;
  category: string;
  tags: string[];
  assets_path: string;
  path: string;
  default_stream: PlaylistSingleMediaDefaultStream;
  media_info: PlaylistSingleMediaInfo;
  audio_transcription: PlaylistSingleMediaAudioTranscription;
  subtitles: {
    language: string;
    contentType: string;
  }[];
  created_at: string;
  updated_at: string;
  state: MediaState;
};

export type PlaylistMediasResponse = {
  playlist: PlaylistResponse;
  medias: PlaylistSingleMedia[];
};

export type PlaylistSingleMediaRow = PlaylistSingleMedia & {
  id: number | string; // very required for KrgDataTable row key
  index?: number;
  thumbnail: string;
  title: string;
  duration: string;
  dateAdded: string;
  status?: string;
};

export type PlaylistFilter = {
  title?: string;
  type?: string[];
  page?: number;
  limit?: number;
  skip?: number;
  sort?: Sort;
  date_range?: DateRange | undefined | string;
  slug?: string;
};

export type PlaylistQuery = {
  title?: string;
  type?: string[];
  page?: number;
  limit?: number;
  skip?: number;
  sort?: string;
  created_range?: string;
  slug?: string;
};

export type GenerateFormType = "tag" | "category" | "custom";
